import Category from '@/models/Category';
import { Family } from '@/models/Family';
import Tag from '@/models/Tag';
import * as Yup from 'yup';

export interface CourseForm {
    mainImage: string;
    name: string;
    author: string;
    description?: string;
    locale: string;
    scormPackageName?: string | null;
    categories: Category[];
    tags: Tag[];
    families?: Family[];
}

export const courseSchema: Yup.ObjectSchema<CourseForm> = Yup.object().shape<CourseForm>({
    mainImage: Yup.string().required(),
    name: Yup.string().required(),
    author: Yup.string().required(),
    description: Yup.string().notRequired(),
    locale: Yup.string().required(),
    categories: Yup.array<Category>().min(1),
    tags: Yup.array<Tag>().min(1),
    families: Yup.array<Family>().notRequired(),
});

export const formInitialState = {
    mainImage: '',
    name: '',
    author: '',
    description: '',
    locale: '',
    scormPackageName: null,
    categories: [],
    tags: [],
    families: [],
};

export const formErrors = {
    mainImageError: false,
    nameError: false,
    authorError: false,
    descriptionError: false,
    localeError: false,
    scormPackageNameError: false,
    categoriesError: false,
    tagsError: false,
};
